"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaBreakpoints = void 0;
const MediaBreakpoints = exports.MediaBreakpoints = {
  forPhoneExtraSmall: "(max-width: 320px)",
  forPhoneSmall: "(max-width: 360px)",
  forPhoneOnly: "(max-width: 767px)",
  forTabletUp: "(min-width: 768px)",
  forTabletOnly: "(min-width: 768px) and (max-width: 1023px)",
  forTabletDown: "(max-width: 1023px)",
  forDesktopUp: "(min-width: 1024px)",
  forDesktopOnly: "(min-width: 1024px) and (max-width: 1499px)",
  forBigDesktopUp: "(min-width: 1500px)"
};

// below is the old set of break points along with whats used in various apps
// export const MediaBreakpoints = {
//   minWidthWeb: "(min-width: 700px)",      // arc(0), deals(7), booking(17), mobile(0)
//   maxWidthPhone: "(max-width: 699px)",    // arc(0), deals(18), booking(43), mobile(0)
//   minWidth_900px: "(min-width: 900px)",   // arc(0), deals(0), booking(3), mobile(0)
//   maxWidthtablarge: "(min-width: 899px)", // arc(0), deals(1), booking(0), mobile(0)
//   maxWidthXsPhone: "(max-width: 359px)"   // arc(0), deals(0), booking(0), mobile(0)
// };